export default {
  id: 'QrCodeModal',
  code: 'CN',
  text: {
    'Close': '关闭',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/QrCode/locale.js